import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-finished',
  templateUrl: './project-finished.component.html',
  styleUrl: './project-finished.component.scss'
})
export class ProjectFinishedComponent implements OnInit {
  breadCrumbItems!: Array<{}>;

  constructor() {}
  ngOnInit(): void {
    // Implementação do ngOnInit
  }

}
